import { Textarea } from 'src/design/atoms/Textarea';

import React from 'react';
import { DatePicker } from 'src/design/atoms/DatePicker';
import { WeatherCard } from 'src/app/jobs/WeatherCard';
import { toWeatherData } from 'src/app/jobs/WeatherCard.types';
import { DAILY_DESCRIPTION_MAX_LENGTH } from 'src/routes/Operations/Daily/components/DailyForm';
import { StepProps } from './types';

export interface DescriptionStepProps extends StepProps {
  onDateChange: (date: Date | null) => void;
}

export const DescriptionStep: React.FC<DescriptionStepProps> = ({
  values,
  setFieldValue,
  selectedJob,
  onDateChange,
}) => {
  const descriptionLength = values.description?.length ?? 0;
  return (
    <>
      <DatePicker
        label="Date"
        value={values.date}
        onChange={(newValue) => {
          onDateChange(newValue ?? null);
        }}
      />
      <Textarea
        label="Description of Daily Activity"
        onChange={(e) => setFieldValue('description', e.target.value)}
        rows={10}
        value={values.description}
        name="description"
        withAsterisk
        maxLength={DAILY_DESCRIPTION_MAX_LENGTH}
        description={`${descriptionLength}/${DAILY_DESCRIPTION_MAX_LENGTH}`}
        inputWrapperOrder={['label', 'input', 'description', 'error']}
      />

      {selectedJob && (
        <WeatherCard
          job={selectedJob}
          onWeatherLoaded={(w) => setFieldValue('weather', w)}
          initialWeather={toWeatherData(values.weather)}
        />
      )}
    </>
  );
};
